import { Button, Form, type FormInstance } from 'antd'
import { useState } from 'react'

interface FeedUrlSourceAuthenticationBasicProps {
  children?: React.ReactNode
  form: FormInstance<any>
  isSubmitted?: boolean
  shouldValidate?: boolean
  onSubmit: (credentials: any) => void
  initialValues?: any
}

function FeedUrlSourceAuthenticationBaseForm({
  children,
  form,
  isSubmitted,
  shouldValidate = false,
  onSubmit,
  initialValues,
}: FeedUrlSourceAuthenticationBasicProps): JSX.Element {
  const [isValid, setIsValid] = useState(!shouldValidate)

  const onFinish = () => {
    const values = form.getFieldsValue()

    if (
      Object.values(values).every(
        (value) => value === undefined || value === '',
      )
    ) {
      onSubmit(null)
      return
    }

    onSubmit(values)
  }

  return (
    <Form
      form={form}
      layout="vertical"
      autoComplete="off"
      onFinish={onFinish}
      {...(shouldValidate
        ? {
            onFieldsChange: (_, all) => {
              setIsValid(!all.some((field) => (field.errors ?? []).length > 0))
            },
          }
        : {})}
      {...(initialValues ? { initialValues } : {})}
    >
      {children}
      <div className="flex justify-between gap-2">
        <Button
          type="default"
          htmlType="button"
          size="large"
          className="flex-1 border border-solid rounded-lg !border-gray-300 hover:!border-gray-200 !text-gray-700 hover:!text-gray-900 !h-auto py-2"
          onClick={() => form.resetFields()}
        >
          Clear
        </Button>
        <Button
          type="primary"
          htmlType="submit"
          size="large"
          loading={isSubmitted}
          disabled={!isValid || isSubmitted}
          className="flex-1 border border-solid rounded-lg bg-primary-600 hover:!bg-primary-700 disabled:!bg-primary-150 text-white !h-auto py-2"
        >
          Confirm
        </Button>
      </div>
    </Form>
  )
}

export default FeedUrlSourceAuthenticationBaseForm
